import ComponentInit from './utils/ComponentInit';
import CareerListing from '4-sections/FilteredListings/CareerListing/CareerListing';

// Format:
// data-component-name: ComponentFunction
// we shall order these in page load critical first
const componentList = { CareerListing };

export default ComponentInit(componentList);
